import React from 'react';
import { useNavigate } from 'react-router-dom';
import {logEventOnPress} from '../../utils/AnalyticsUtil';
import BaseComponent from '../BaseComponent';

const ButtonPrimary = ({
  label,
  isDisabled,
  onClick,
  id,
  name,
  cssClass,
  value = ','
}) => {
  const handleOnClick = () => {
    logEventOnPress('onButtonPress', name, value);
    onClick();
  };
  return (
    <BaseComponent name={'ButtonPrimary'}>
      <div className="input-conatainer">
        <button
          name={name}
          type="button"
          className={`btn-primary ${isDisabled ? 'btn-disabled' : ''} ${cssClass}`}
          onClick={handleOnClick}
          id={id}
        >
          {label}
        </button>
      </div>
    </BaseComponent>
  );
};

const ButtonLink = ({
  children,
  cssClass,
  route,
  id,
  name,
  value = ','
}) => {
  let navigate = useNavigate();
  const onClickOfButton = () => {
    logEventOnPress('onButtonPress', name, value);
    navigate(route);
  };
  return (
    <BaseComponent name={'ButtonLink'}>
      <button type="button" name={name} className={`link ${cssClass}`} onClick={onClickOfButton} id={id}>
        {children}
      </button>
    </BaseComponent>
  );
};

const ButtonCustom = ({
  name,
  children,
  cssClass,
  onClick,
  disabled,
  id,
  value = ','
}) => {
  const handleOnClick = (e) => {
    logEventOnPress('onButtonPress', name, value);
    onClick(e);
  };
  return (
    <BaseComponent name={'ButtonCustom'}>
      <button
        name={name}
        type="button"
        className={cssClass}
        onClick={handleOnClick}
        disabled={disabled}
        id={id}
      >
        {children}
      </button>
    </BaseComponent>
  );
};

export { ButtonPrimary, ButtonLink, ButtonCustom };
